module.exports = __webpack_public_path__ + "img/ex-kerry.07c464b5.jpg";